import { render, staticRenderFns } from "./SlideOutIcon.vue?vue&type=template&id=61aa49e9&"
import script from "./SlideOutIcon.vue?vue&type=script&lang=js&"
export * from "./SlideOutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports